import { DataService } from './dataService'
export const revenuecostService = {

    // For Revenue/Invoice
    createInvoice: async (data) => {
        return DataService.post('/create/invoice', data)
    },
    updateInvoice: async (data) => {
        return DataService.post('/update/invoice', data)
    },
    deleteInvoice: async (data) => {
        return DataService.get('/delete/invoice', data)
    },

    getInvoice: async (data) => {
        return DataService.get('/get/invoice', data)
    },

    updateStatus: async (data) => {
        return DataService.post('/updateStatus/invoice', data)
    },

    // For Cost
    createCost: async (data) => {
        return DataService.post('/create/cost', data)
    },
    billCreateQB: async (data) => {
        return DataService.post('/admin/qbook/billCreate', data)
    },
    billUpdateQB: async (data) => {
        return DataService.post('/admin/qbook/billUpdate', data)
    },
    getCost: async (data) => {
        return DataService.get('/get/costs', data)
    },

    updateCostStatus: async (data) => {
        return DataService.post('/updateStatus/cost', data)
    },

    // Intuit - QuickBook
    qbookAuth: (data) => {
        return DataService.get('/admin/qbook/auth', data)
    },

    createToken: (data) => {
        return DataService.post('/admin/qbook/createToken', data)
    },

    getCompanyInfo: (data) => {
        return DataService.get('/admin/qbook/getCompanyInfo', data)
    },

    customerCreate: async (data) => {
        // let result = await DataService.post('/admin/qbook/customerCreate', data)
    },

    itemCreate: async (data) => {
        // let result = await DataService.post('/admin/qbook/itemCreate', data)
    },
    invoiceCreateQB: async (data) => {
        return await DataService.post('/admin/qbook/invoiceCreate', data)
    },
    invoiceUpdateQB: async (data) => {
        return await DataService.post('/admin/qbook/invoiceUpdate', data)
    },
    invoiceDeleteQB: async (data) => {
        return await DataService.post('/admin/qbook/invoiceDelete', data)
    },
    invoicePayment: async (data) => {
        return await DataService.post('/admin/qbook/invoicePayment', data)
    },
    profitAndLoss: async (data) => {
        return await DataService.post('/admin/qbook/profitAndLoss', data)
    },
    getVendors: async (data) => {
        return await DataService.get('/admin/get_vendor_qb', data)
    },
    deleteCost: async (data) => {
        return await DataService.post('/delete/costs', data)
    },
    deleteBill: async (data) => {
        return await DataService.post('/admin/qbook/deleteBill', data)
    },
    
}
